var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "bank-slip-query",
            {
              ref: "bankSlipQuery",
              attrs: {
                identify: "bankSlipRegister",
                "view-source": "bankSlipRegister",
                "config-module": "1200",
                "is-register": true,
                "page-mode": 0,
                "check-role": false,
                "ar-field": "ar",
                "rate-field": "rate",
                "total-type": "revenueAbs",
                "grid-config-module": "1200001"
              },
              scopedSlots: _vm._u([
                {
                  key: "searchAreaHeader",
                  fn: function() {
                    return undefined
                  },
                  proxy: true
                }
              ])
            },
            [
              _c(
                "div",
                { attrs: { slot: "operations" }, slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_fmBankSlip_bankSlipRegister"
                          ]),
                          expression:
                            "$checkPermission(['button_fmBankSlip_bankSlipRegister'])"
                        }
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.addBtnClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_fmBankSlip_bankSlipRegister"
                          ]),
                          expression:
                            "$checkPermission(['button_fmBankSlip_bankSlipRegister'])"
                        }
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.modifyBtnClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Modify")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_fmBankSlip_bankSlipRegister"
                          ]),
                          expression:
                            "$checkPermission(['button_fmBankSlip_bankSlipRegister'])"
                        }
                      ],
                      attrs: { type: "danger" },
                      on: { click: _vm.delBtnClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_fmBankSlip_bankSlipRegister"
                          ]),
                          expression:
                            "$checkPermission(['button_fmBankSlip_bankSlipRegister'])"
                        }
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.releaseBtnClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Publish")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_fmBankSlip_bankSlipRegister"
                          ]),
                          expression:
                            "$checkPermission(['button_fmBankSlip_bankSlipRegister'])"
                        }
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.cancelReleaseBtnClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CancelPublishment")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_fmBankSlip_bankSlipRegister"
                          ]),
                          expression:
                            "$checkPermission(['button_fmBankSlip_bankSlipRegister'])"
                        }
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.downloadImportTemplate }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_DownloadImportTemplate"))
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_fmBankSlip_bankSlipRegister"
                          ]),
                          expression:
                            "$checkPermission(['button_fmBankSlip_bankSlipRegister'])"
                        }
                      ],
                      staticStyle: {
                        display: "inline-block",
                        "margin-left": "5px"
                      }
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            action:
                              _vm.URL.act.actualAmount.importActualAmountUrl,
                            headers: {
                              sessionId: _vm.$store.getters.userInfo.sessionId
                            },
                            data: {
                              branchId: _vm.$store.getters.currentOfficeId
                            },
                            "show-file-list": false,
                            accept: ".xlsx",
                            "before-upload": _vm.beforeUpload,
                            "on-success": _vm.uploadSuccess
                          }
                        },
                        [
                          _c("el-button", { attrs: { type: "primary" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_ImportBankSlip"))
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("bank-slip-window", {
        attrs: {
          visible: _vm.bankSlipWindow.visible,
          "pre-payment": _vm.bankSlipWindow.prePayment,
          params: _vm.bankSlipWindow.params,
          "show-publish": _vm.bankSlipWindow.showPublish,
          ar: true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.bankSlipWindow, "visible", $event)
          },
          refresh: _vm.refreshPageHandler
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }